import React from 'react';
import Table from '@components/Table';
import { parseTime } from '@/helpers/deliveryHistoryUtils';
import { StatsItem } from './types';

interface DeliveryHistoryStatsProps {
  statsData: StatsItem[];
  globalSearch: string;
  filteredItems?: any[];
}

const DeliveryHistoryStats: React.FC<DeliveryHistoryStatsProps> = ({ 
  statsData, 
  globalSearch, 
  filteredItems 
}) => {
  const statsTableColumns = [
    {
      key: 'files',
      label: 'Number of Files',
      sortable: true,
      render: (row: { numFiles: string }) => row.numFiles,
    },
    {
      key: 'errors',
      label: 'Number of Errors',
      sortable: false,
      render: (row: { numErrors: string }) => row.numErrors,
    },
    {
      key: 'duration',
      label: 'Average Duration (s)',
      sortable: false,
      render: (row: { avgTotalTime: string }) => parseInt(row.avgTotalTime, 10) / 1000 || "-",
    },
    {
      key: 'process',
      label: 'Average Processing Time (s)',
      sortable: false,
      render: (row: { avgProcessingTime: string }) => parseTime(row.avgProcessingTime),
    },
    {
      key: 'delivery',
      label: 'Average Delivery Time (s)',
      sortable: false,
      render: (row: { avgDeliveryTime: string }) => parseTime(row.avgDeliveryTime),
    },
  ];

  // If we have a global search active, calculate stats from filtered items
  const statsTableData = globalSearch && (filteredItems?.length ?? 0) > 0
    ? [{
        data: {
          numFiles: filteredItems?.length.toString(),
          numErrors: filteredItems?.filter((item: any) => item.msg && item.msg !== '-').length.toString(),
          avgTotalTime: (filteredItems ?? []).reduce((sum: number, item: any) => sum + (parseInt(item.total, 10) || 0), 0) / (filteredItems?.length ?? 1),
          avgProcessingTime: "0 00:00:00.000000000", // Simplified as we can't easily calculate this from filtered items
          avgDeliveryTime: "0 00:00:00.000000000", // Simplified as we can't easily calculate this from filtered items
        }
      }]
    : statsData?.map((item: any) => {
        return {
          data: item
        };
      });

  return (
    <Table columns={statsTableColumns} data={statsTableData} keyprop="numFiles" />
  );
};

export default DeliveryHistoryStats;
